module.exports = __webpack_public_path__ + "img/achievement_29.4247070a.png";